import { getPartnerShortCode } from '@qwealth/qcore';

export const getLogAttachmentPath = (householdId: string, uuid: string): string => {
  const shortCode = getPartnerShortCode(householdId);
  return `${shortCode}/${householdId}/Internal/Call Log Attachments/${uuid}/`;
};
